import PropTypes from 'prop-types';
import regulationImage1 from '../images/regulation_image1.png';
import regulationImage2 from '../images/regulation_image2.png';
import regulationImage3 from '../images/regulation_image3.png';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const TextAndImage = (props) => {
  return (
    <Stack>
      <Stack direction='row' spacing={1} marginBottom='16px' width='256px' height='64px' >
        <Typography variant='label14' >
          {props.number}
        </Typography>
        <Typography whiteSpace='pre-wrap' variant='label14'>
          {props.text}
        </Typography>
      </Stack>
      <img src={props.src} alt='運転規制/解除 選択時のDTAC側表示イメージ' width='256px' height='341px' />
    </Stack>
  );
};

const NextIcon = () => {
  return (
    <Stack justifyContent='center' padding='0px 16px' height='341px'>
      <NavigateNextIcon sx={{ color: 'darkgray' }} />
    </Stack>
  );
};

const RegulationImageDialog = (props) => {
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      maxWidth='lg'
    >
      <DialogTitle variant='body16bold' textAlign='center' position='relative'>
        運転規制/解除 選択時のDTAC側表示イメージ
        <IconButton
          sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: '45px 52px 75px 52px' }}>
        <Stack direction='row' alignItems='end'>
          <TextAndImage
            number='①'
            text={'送信先のDTAC画面上部に\n通知バーが表示される'}
            src={regulationImage1}
          />
          <NextIcon />
          <TextAndImage
            number='②'
            text={'通知バーをタップすると\n受領ボタン付きの\n詳細情報ダイアログが表示される'}
            src={regulationImage2}
          />
          <NextIcon />
          <TextAndImage
            number='③'
            text={'受領ボタンをタップすると\n元の画面に戻る'}
            src={regulationImage3}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default RegulationImageDialog;

TextAndImage.propTypes = {
  number: PropTypes.string,
  text: PropTypes.string,
  src: PropTypes.string,
};

RegulationImageDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
